// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';
import { windowWrapper } from '@clubmed/utils';
import { get } from 'lodash';

import config from 'Config';
import { BREAKPOINTS, MEDIA_QUERIES } from './Responsive.constants.js';

function getDOMAspect(isAppMounted: boolean) {
  let domCharacteristics = {
    viewportWidthPX: 0,
    viewportHeightPX: 0,
    htmlFontSize: 0,
  };

  if (isAppMounted) {
    domCharacteristics = {
      viewportWidthPX: windowWrapper.getClientWidth(),
      viewportHeightPX: windowWrapper.getClientHeight(),
      htmlFontSize: parseInt(windowWrapper.getFontSize(), 10),
    };
  }

  return domCharacteristics;
}

function getCurrentBreakpoint(userAgent: string = '', isAppMounted: boolean) {
  if (!isAppMounted) {
    if (
      config.get('featureFlipping.ssr.mobile-first') ||
      !userAgent ||
      /(mobile|tablet|iPhone|iPad|Android)/i.test(userAgent)
    ) {
      return BREAKPOINTS.XXS;
    }

    return BREAKPOINTS.XL;
  }

  return MEDIA_QUERIES.reduce((previousValue, currentValue) => {
    return windowWrapper.matchMediaQuery(currentValue.mediaquery) ? currentValue : previousValue;
  }).breakpoint;
}

function isLandscape(isAppMounted: boolean) {
  return isAppMounted ? windowWrapper.matchMediaQuery('all and (orientation:landscape)') : false;
}

function isRTL(isAppMounted: boolean) {
  return isAppMounted ? windowWrapper.getDocumentElement().dir === 'rtl' : false;
}

function domRectToSize({ width, height }) {
  return { width, height };
}

function getGridCellNodeSize(node, maxDepth, depth) {
  const parentElement = get(node, 'parentElement');

  if (depth > maxDepth || !parentElement) {
    return null;
  }
  /* exit on Backdrop aka full screen component */
  if (parentElement.classList.contains('escape-responsive-helper')) {
    return null;
  }
  if (
    parentElement.classList.contains('GridCell') ||
    parentElement.classList.contains('image-responsive-cell')
  ) {
    return domRectToSize(parentElement.getBoundingClientRect() || {});
  }
  return getGridCellNodeSize(parentElement, maxDepth, depth + 1);
}

function getGridCellSize(component: Element, maxDepth: number = 20) {
  return getGridCellNodeSize(ReactDOM.findDOMNode(component), maxDepth, 0);
}

export { getCurrentBreakpoint, getDOMAspect, isLandscape, isRTL, getGridCellSize };
